function isObject(obj) { return obj.constructor === {}.constructor }
function isString(obj) { return obj.constructor === 'test'.constructor }
function isArray(obj) { return obj.constructor === [].constructor }
function isNumber(obj) { return !isNaN(parseFloat(obj)) }
function isBoolean(obj) { return typeof(obj) == 'boolean' }

function getType(object) {
  if (object === null) {
    return 'null';
  } else if (object === undefined) {
    return 'undefined';
  } else if (isString(object)) {
    try {
    /* Check if string is a date string
      The length check is present cause we only want to accept ISO strings with both time and date.
      This also avoids a string like '2014' to be interpreted as a timestamp */
      var tryDate = new Date(object);
      if (object.length > 18 && !isNaN(tryDate.getTime())) {
        return 'TIMESTAMP';
      } else {
        return 'STRING';
      }
    }
    catch(err) {
      return 'STRING';
    }
  } else if (isArray(object)) {
      return 'Array';
    } else if (isObject(object)) {
      return 'Object';
    } else if (isNumber(object)) {
      if (object.toString().indexOf('.') > -1) {
        return 'FLOAT';
      } else {
        return 'INTEGER';
      }
    } else if (isBoolean(object)) {
      return 'BOOLEAN';
    } else {
    return undefined;
  }
}

function createField(type, name, mode) {
  if (mode) {
    return {
      name: name,
      type: type,
      mode: mode
    };
  }

  return {
    name: name,
    type: type
  };
}

class Generator {
  hasNullOrUndefinedProps = false;
  fields = [];
  
  run(fields, o) {
    this.fields = this.traverse(fields, o);
    return this;
  }

  traverseArray(name, fields, o) {
    if (o.length > 0) {
      // We only want to look at the first item in the array.
      // The rest should be just like it, and will be expressed through mode=repeated.
  
      const firstElement = o[0];
      const type = getType(firstElement);
  
      if (type == 'Object') {
        // If the array has an object as the first element, we need to create a record type with more fields
        const field = createField('record', name, 'repeated');
        field.fields = this.traverse(fields, firstElement);
        return field;
      } else {
        // If the array only has native types, we only created a simple repeated field
        return createField(type, name, 'repeated');
      }
    }
    return undefined;
  }
  
  traverse(fields, o) {
    for (let i in o) {
      const name = i;
      const type = getType(o[i]);
      let field;
  
      if (type == 'null' || type == 'undefined') {
          // Skip empty fields.
        this.hasNullOrUndefinedProps = true;
        fields.push(createField('STRING', name, undefined));
      } else if (type == 'Array') {
        field = this.traverseArray(name, [], o[i]);
        if (field != undefined)
          fields.push(field);
        }
      else if (type == 'Object') {
        field = createField('record', name, undefined);
        field.fields = this.traverse([], o[i]);
        fields.push(field);
      } else {
        fields.push(createField(type, name, undefined));
      }
    }
  
    return fields;
  }
}

export default function(json, done) {
  try {
    done(new Generator().run([], JSON.parse(json)));
  } catch (e) {
    alert('Failed to parse JSON');
  }
}